module.exports = __webpack_public_path__ + "img/pay-loading.fbdd419f.png";